import { Outlet, ScrollRestoration } from 'react-router-dom';

/**
 * Raiz sem path acima de todas as ramificações do router.
 *
 * Existe para o `ScrollRestoration`: numa SPA a janela não volta ao topo
 * sozinha, e quem saía da vitrine rolada caía no meio da próxima tela. Com ele,
 * navegação nova abre no topo e o voltar do navegador devolve a posição salva.
 *
 * Precisa ser renderizado UMA vez, acima dos layouts — por isso não mora em
 * nenhum deles. Mudança de filtro na query string não é navegação de tela: os
 * hooks de filtro passam `preventScrollReset`.
 */
export function RouterRoot() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
